/**
 * Query keys for Promo Campaign API hooks
 *
 * Centralized query keys enable consistent cache invalidation across all promo campaign hooks.
 *
 * Usage:
 *   import { promoCampaignQueryKeys } from '~/hooks/apis/promoCampaigns/promoCampaignQueryKeys';
 */
import type { PromoCampaignSearchParams } from '~/services/LuxLoyalty';

export const promoCampaignQueryKeys = {
  all: ['loyalty', 'promo-campaigns'] as const,
  lists: () => [...promoCampaignQueryKeys.all, 'list'] as const,
  list: (filters?: PromoCampaignSearchParams) => [...promoCampaignQueryKeys.lists(), filters] as const,
  details: () => [...promoCampaignQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...promoCampaignQueryKeys.details(), id] as const,
};
